import { IconStyled, IconStylesProps } from './IconStyles';

export const Calendar = ({ size = '14px', className = '' }: Partial<IconStylesProps>) => (
  <IconStyled
    size={size}
    className={className}
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M12.4444 1.55556H11.6667V0H10.1111V1.55556H3.88889V0H2.33333V1.55556H1.55556C0.7 1.55556 0 2.25556 0 3.11111V14C0 14.8556 0.7 15.5556 1.55556 15.5556H12.4444C13.3 15.5556 14 14.8556 14 14V3.11111C14 2.25556 13.3 1.55556 12.4444 1.55556ZM12.4444 14H1.55556V6.22222H12.4444V14ZM1.55556 4.66667V3.11111H12.4444V4.66667H1.55556ZM3.11111 7.77778H10.8889V9.33333H3.11111V7.77778ZM3.11111 10.8889H8.55556V12.4444H3.11111V10.8889Z" fill="currentColor" />
  </IconStyled >
);
